import axios from 'axios';
import { createRedirectUrl } from '../../features/editor/apiUtils';
import { Mixpanel } from './mixpanelUtil';
import {
  getInnerFieldOptions,
  loadCollectionItems,
} from '../../features/editor/plugins/pluginComponentApi';
import { builderSurfaceJsonContentHeader } from './restApiHeaderUtils';
import { getErrorMessageFromResponse } from './errorUtils';
import { changeActiveInActive, changeStyelDisplay } from './geditor_utils';
import { getCookie, updateUserIpInCookie } from '../../features/home/app_util';
import { toast } from 'react-toastify';
import { snakeCaseToTitleCase } from './api_utils';
import {
  FieldTypes,
  SelectOptionFields,
  linkField,
  emailField,
  largeTextNumberField,
} from 'drapcode-constant';
export const categoryOrderMap = {
  'Frequently Used': 0,
  Basic: 1,
  'AI Components': 2,
  Layout: 3,
  CMS: 4,
  Advanced: 5,
  Forms: 6,
  Social: 7,
  Charts: 8,
  'Payment Gateway': 9,
  Shopping: 10,
};
const VISIBILITY_SUPPORTED_FIELD_TYPES = [
  FieldTypes.boolean.id,
  ...SelectOptionFields,
  ...linkField,
  ...emailField,
  ...largeTextNumberField,
];
const getFieldTypeName = (fieldType) => {
  return FieldTypes[fieldType].name;
};
export const configureEditorCommands = async (
  editor,
  project,
  crntVersion,
  versions,
  togglePopover,
  slug,
  togglePreview,
  geditorBuilderOption,
) => {
  const commands = editor.Commands;
  let previewUrl = `https://${project.seoName}_v${crntVersion}.preview.${process.env.REACT_APP_EXCHANGE_SURFACE}`;
  let redirectUrl = createRedirectUrl();

  //Override Preview URL for Dev Environment
  if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
    previewUrl = `http://${project.seoName}_v${crntVersion}.preview.${process.env.REACT_APP_EXCHANGE_SURFACE}`;
  }

  if (slug) {
    previewUrl = `${previewUrl}${slug}`;
  }
  commands.add('custom-preview', (editor) => {
    // window.open(previewUrl, '_blank');
    togglePreview();
  });

  commands.add('custom-build', async (editor) => togglePopover());

  commands.add('code-editor-open', (editor) => {
    let token = getCookie('token');
    if (!token) {
      token = '';
    }
    window.location.href = `${redirectUrl}deployment-setting/${crntVersion}/v/${project.uuid}/code-ui?token=${token}`;
  });

  commands.add('drapcode-add-sibling:open-modal', {
    run(editor, sender) {
      const bm = editor.BlockManager;

      let categories = bm.getCategories();
      categories.each((category) => {
        category.set('open', true);
      });

      // Render new set of blocks
      const allBlocks = bm.getAll();
      const { filtered, filteredSections, filteredPreBuiltLayouts, filteredThemePages } =
        filterBlocksByCategory(allBlocks);

      const sectionsBlocksEl = bm.render(filteredSections, { external: true });
      const preBuiltLayoutsBlocksEl = bm.render(filteredPreBuiltLayouts, { external: true });
      const themePagesBlocksEl = bm.render(filteredThemePages, { external: true });

      // Render all blocks (inside the global collection)
      bm.render(filtered);

      // const newBlocksEl = bm.render('', { external: true });
      const newBlocksEl = bm.render(filtered, { external: true });
      const id = `add-sibling-components-modal`;
      const blocks = document.createElement('div');
      const title = 'Components';

      blocks.setAttribute('id', `add-sibling-components-blocks`);
      newBlocksEl.setAttribute('id', `add-sibling-components-container`);
      // blocks.appendChild(newBlocksEl);

      blocks.innerHTML = `
    <ul class="nav nav-tabs">
      <li class="nav-item"><a class="active nav-link drapcode-link__components" title="Components"><i class="wb webconnect-cubes"></i> Components</a></li>
      <li class="nav-item"><a class="nav-link drapcode-link__sections" title="Sections"><i class="wb webconnect-grid-3x2-gap-fill"></i> Sections</a></li>
      <li class="nav-item"><a class="nav-link drapcode-link__prebuilt-layouts" title="PreBuilt Layouts"><i class="wb webconnect-gem"></i> Pre-Built Layouts</a></li>
      <li class="nav-item"><a class="nav-link drapcode-link__prebuilt-layouts" title="Theme Pages"><i class="wb webconnect-gem"></i> Theme Pages</a></li>
    </ul>
    
    <div id="tab-content-components" class="gjs-tabcontent">
      <div class="gjs-container">
        <div class="gjs-row"></div>
      </div>
    </div>
    <div id="tab-content-sections" class="gjs-tabcontent">
      <div class="gjs-container">
        <div class="gjs-row"></div>
      </div>
    </div>
    <div id="tab-content-prebuilt-layouts" class="gjs-tabcontent">
    <div class="gjs-container">
      <div class="gjs-row"></div>
    </div>
  </div>
  <div id="tab-content-theme-pages" class="gjs-tabcontent">
    <div class="gjs-container">
      <div class="gjs-row"></div>
    </div>
  </div>
    `;

      //Button Inputs and tab input
      const componentsButton = blocks.querySelector('.drapcode-link__components');
      const componentsTab = blocks.querySelector('#tab-content-components');

      const sectionsButton = blocks.querySelector('.drapcode-link__sections');
      const sectionsTab = blocks.querySelector('#tab-content-sections');

      const prebuiltLayoutsButton = blocks.querySelector('.drapcode-link__prebuilt-layouts');
      const prebuiltLayoutsTab = blocks.querySelector('#tab-content-prebuilt-layouts');

      const themePagesButton = blocks.querySelector('.drapcode-link__theme-pages');
      const themePagesTab = blocks.querySelector('#tab-content-theme-pages');

      componentsTab.appendChild(newBlocksEl);
      componentsTab.style.display = 'block';

      componentsButton.addEventListener('click', (ev) => {
        ev.currentTarget.className += ' active';
        changeActiveInActive([sectionsButton, themePagesButton, prebuiltLayoutsButton]);
        componentsTab.appendChild(newBlocksEl);
        changeStyelDisplay([componentsTab], [prebuiltLayoutsTab, themePagesTab, sectionsTab]);
      });
      sectionsButton.addEventListener('click', (ev) => {
        ev.currentTarget.className += ' active';
        changeActiveInActive([componentsButton, themePagesButton, prebuiltLayoutsButton]);
        sectionsTab.appendChild(sectionsBlocksEl);
        changeStyelDisplay([sectionsTab], [prebuiltLayoutsTab, themePagesTab, componentsTab]);
      });
      prebuiltLayoutsButton.addEventListener('click', (ev) => {
        ev.currentTarget.className += ' active';
        changeActiveInActive([componentsButton, themePagesButton, sectionsButton]);
        prebuiltLayoutsTab.appendChild(preBuiltLayoutsBlocksEl);
        changeStyelDisplay([prebuiltLayoutsTab], [sectionsTab, themePagesTab, componentsTab]);
      });
      themePagesButton.addEventListener('click', (ev) => {
        ev.currentTarget.className += ' active';
        changeActiveInActive([componentsButton, prebuiltLayoutsButton, sectionsButton]);
        themePagesTab.appendChild(themePagesBlocksEl);
        changeStyelDisplay([themePagesTab], [sectionsTab, prebuiltLayoutsTab, componentsTab]);
      });

      this.blocks = blocks;
      editor.Modal.open({ title, content: blocks })
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));
    },

    stop(editor) {
      editor.Modal.close();
    },
  });

  commands.add('custom-open-blocks', {
    run(editor, sender) {
      Mixpanel.track('Clicked on- Add Compoenets Big Plus Circle Button');
      const bm = editor.BlockManager;
      const pn = editor.Panels;
      if (!this.blocks) {
        //Modify Components Category Order
        let categories = editor.BlockManager.getCategories();
        categories.each((category) => {
          category.set('open', true);
          category.set('order', categoryOrderMap[category.id]);
        });

        const allBlocks = bm.getAll();
        const { filtered, filteredSections, filteredPreBuiltLayouts, filteredThemePages } =
          filterBlocksByCategory(allBlocks);

        const sectionsBlocksEl = bm.render(filteredSections, { external: true });
        const preBuiltLayoutsBlocksEl = bm.render(filteredPreBuiltLayouts, { external: true });
        const themePagesBlocksEl = bm.render(filteredThemePages, { external: true });

        // Render all blocks (inside the global collection)
        bm.render(filtered);

        // const newBlocksEl = bm.render('', { external: true });
        const newBlocksEl = bm.render(filtered, { external: true });
        const id = 'views-add-components-container';
        const blocks = document.createElement('div');
        blocks.setAttribute('id', 'blocks');
        const panels = pn.getPanel(id) || pn.addPanel({ id });
        // blocks.appendChild(newBlocksEl);

        blocks.innerHTML = `
      <ul class="nav nav-tabs">
        <li class="nav-item"><a class="active nav-link drapcode-link__components" title="Components"><i class="wb webconnect-cubes"></i> Components</a></li>
        <li class="nav-item"><a class="nav-link drapcode-link__sections" title="Sections"><i class="wb webconnect-grid-3x2-gap-fill"></i> Sections</a></li>
        <li class="nav-item"><a class="nav-link drapcode-link__prebuilt-layouts" title="PreBuilt Layouts"><i class="wb webconnect-gem"></i> Pre-Built Layouts</a></li>
        <li class="nav-item"><a class="nav-link drapcode-link__theme-pages" title="Theme Pages"><i class="wb webconnect-newspaper"></i> Theme Pages</a></li>
      </ul>
      
      <div id="tab-content-components" class="gjs-tabcontent">
        <div class="gjs-container">
          <div class="gjs-row"></div>
        </div>
      </div>
      <div id="tab-content-sections" class="gjs-tabcontent">
        <div class="gjs-container">
          <div class="gjs-row"></div>
        </div>
      </div>
      <div id="tab-content-prebuilt-layouts" class="gjs-tabcontent">
      <div class="gjs-container">
        <div class="gjs-row"></div>
      </div>
    </div>
    <div id="tab-content-theme-pages" class="gjs-tabcontent">
      <div class="gjs-container">
        <div class="gjs-row"></div>
      </div>
    </div>
      `;

        //Button Inputs and tab input
        const componentsButton = blocks.querySelector('.drapcode-link__components');
        const componentsTab = blocks.querySelector('#tab-content-components');

        const sectionsButton = blocks.querySelector('.drapcode-link__sections');
        const sectionsTab = blocks.querySelector('#tab-content-sections');

        const prebuiltLayoutsButton = blocks.querySelector('.drapcode-link__prebuilt-layouts');
        const prebuiltLayoutsTab = blocks.querySelector('#tab-content-prebuilt-layouts');

        const themePagesButton = blocks.querySelector('.drapcode-link__theme-pages');
        const themePagesTab = blocks.querySelector('#tab-content-theme-pages');

        componentsTab.appendChild(newBlocksEl);
        componentsTab.style.display = 'block';

        componentsButton.addEventListener('click', (ev) => {
          ev.currentTarget.className += ' active';
          changeActiveInActive([sectionsButton, prebuiltLayoutsButton, themePagesButton]);
          changeStyelDisplay([componentsTab], [sectionsTab, prebuiltLayoutsTab, themePagesTab]);
        });
        sectionsButton.addEventListener('click', (ev) => {
          ev.currentTarget.className += ' active';
          changeActiveInActive([componentsButton, prebuiltLayoutsButton, themePagesButton]);
          sectionsTab.appendChild(sectionsBlocksEl);
          changeStyelDisplay([sectionsTab], [componentsTab, prebuiltLayoutsTab, themePagesTab]);
        });
        prebuiltLayoutsButton.addEventListener('click', (ev) => {
          ev.currentTarget.className += ' active';
          changeActiveInActive([componentsButton, sectionsButton, themePagesButton]);
          prebuiltLayoutsTab.appendChild(preBuiltLayoutsBlocksEl);
          changeStyelDisplay([prebuiltLayoutsTab], [componentsTab, sectionsTab, themePagesTab]);
        });
        themePagesButton.addEventListener('click', (ev) => {
          ev.currentTarget.className += ' active';
          changeActiveInActive([componentsButton, sectionsButton, prebuiltLayoutsButton]);
          themePagesTab.appendChild(themePagesBlocksEl);
          changeStyelDisplay([themePagesTab], [componentsTab, sectionsTab, prebuiltLayoutsTab]);
        });

        panels.set('appendContent', blocks).trigger('change:appendContent');
        this.blocks = blocks;
      }
      this.blocks.style['max-height'] = '500px';
      this.blocks.style['overflow'] = 'auto';
      this.blocks.classList.add('blocks');
      this.blocks.classList.add('show');
      this.blocks.parentElement.classList.add('show');
      this.blocks.classList.remove('hide');
      this.blocks.parentElement.classList.remove('hide');
    },

    stop() {
      const blocks = this.blocks;
      blocks &&
        (blocks.classList.remove('show'),
        blocks.parentElement.classList.remove('show'),
        blocks.classList.add('hide'),
        blocks.parentElement.classList.add('hide'));
    },
  });
  commands.add('switch-version', {
    run(editor, sender) {
      Mixpanel.track('Clicked on- Switch Version Button');
      const bm = editor.BlockManager;
      const pn = editor.Panels;
      if (!this.blocks) {
        //Modify Components Category Order
        const id = 'switch-version-container';
        const blocks = document.createElement('div');
        blocks.setAttribute('id', 'blocks');
        const panels = pn.getPanel(id) || pn.addPanel({ id });
        versions = versions.map((version) => {
          if (version.currentVersion == crntVersion) {
            return `<option value="${version.currentVersion}" selected="selected">v${version.currentVersion}</option>`;
          } else {
            return `<option value="${version.currentVersion}">v${version.currentVersion}</option>`;
          }
        });
        blocks.innerHTML = `<div class="gjs-container">
          <div class="gjs-row">
            <label>Switch Version:</label>
            <select id="switchVersion" class="form-control">
              ${versions}
            </select>
          </div>
        </div>
      `;

        panels.set('appendContent', blocks).trigger('change:appendContent');
        this.blocks = blocks;
        const switchVersion = blocks.querySelector('#switchVersion');
        switchVersion.addEventListener('change', (ev) => {
          const { target } = ev;
          const { value } = target;
          const header = builderSurfaceJsonContentHeader(project.uuid);
          const serverUrl = process.env.REACT_APP_BUILDER_ENGINE;
          axios
            .get(`${serverUrl}v${value}/pages/${project.uuid}/default-page`, header)
            .then(({ data }) => {
              window.location.href = `/editor/${value}/v/${project.uuid}/pages/${data.uuid}`;
            })
            .catch((err) => {
              const errMsg = getErrorMessageFromResponse(err.response);
              toast.error(`No Default Page found for this version : ${errMsg}`, {});
            });
        });
      }
      this.blocks.style['max-height'] = '300px';
      this.blocks.style['overflow'] = 'auto';
      this.blocks.classList.add('blocks');
      this.blocks.classList.add('show');
      this.blocks.parentElement.classList.add('show');
      this.blocks.classList.remove('hide');
      this.blocks.parentElement.classList.remove('hide');
    },

    stop() {
      const blocks = this.blocks;
      blocks &&
        (blocks.classList.remove('show'),
        blocks.parentElement.classList.remove('show'),
        blocks.classList.add('hide'),
        blocks.parentElement.classList.add('hide'));
    },
  });
  editor.Commands.add('shortcut', {
    run(editor, sender) {
      const globalSearchEvent = new CustomEvent('toggleGlobalSearch', {
        detail: { visible: true },
      });
      window.dispatchEvent(globalSearchEvent);
    },
  });

  await addCompVisibilityCommand(commands, geditorBuilderOption, crntVersion);
  await addCompCodeCommand(commands, geditorBuilderOption, crntVersion);
};

async function addCompVisibilityCommand(commands, geditorBuilderOption, crntVersion) {
  commands.add('tlb-custom-compvisibility', {
    async run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const selectedComponent = this.target;
      if (selectedComponent) {
        let selectedComponentAttrs = selectedComponent.getAttributes();
        const parentDataGroup = selectedComponent.closestType('data-group');
        const parentDataTable = selectedComponent.closestType('data-table');
        const hasParentCMS = !!(parentDataGroup || parentDataTable);
        const {
          bindCollectionOptions,
          collections,
          projectId,
          project,
          installedPlugins,
          snippetCollectionTraitOptions,
        } = geditorBuilderOption || '';
        const { environments } = project || '';
        const { page } = bindCollectionOptions || '';
        const { collectionFrom: pageCollectionFrom, collectionId: pageCollectionId } = page || '';
        const multiTenantSAASPlugin = installedPlugins.find((e) => e.code === 'MULTI_TENANT_SAAS');
        const hasMultiTenantPlugin = !!multiTenantSAASPlugin;
        let enableMultiTenant = false;
        let multiTenantCollection = '';
        let userSettingsCollection = '';
        let subTenantCollection = '';
        if (multiTenantSAASPlugin && hasMultiTenantPlugin) {
          const { setting } = multiTenantSAASPlugin || '';
          const {
            multiTenantCollection: multiTenantCollectionId,
            userSettingsCollection: userSettingsCollectionId,
            subTenantCollection: subTenantCollectionId,
          } = setting || '';
          multiTenantCollection = collections.find(
            (collection) => collection.uuid === multiTenantCollectionId,
          );
          userSettingsCollection = collections.find(
            (collection) => collection.uuid === userSettingsCollectionId,
          );
          subTenantCollection = collections.find(
            (collection) => collection.uuid === subTenantCollectionId,
          );
          enableMultiTenant = Object.keys(multiTenantCollection).length ? true : false;
        }

        const hasPageCollection = pageCollectionFrom === 'COLLECTION' && pageCollectionId;
        let snippetCollectionName = '';
        let snippetType = '';
        if (snippetCollectionTraitOptions && snippetCollectionTraitOptions.collection) {
          snippetCollectionName = snippetCollectionTraitOptions.collection.collectionId;
          snippetType = snippetCollectionTraitOptions.snippet.snippetType;
        }
        const visibilityContent = document.createElement('div');
        const title = 'Visibility';

        visibilityContent.setAttribute('id', `custom-compvisibility`);
        loadVisibilityPanelContent(
          visibilityContent,
          hasPageCollection,
          hasParentCMS,
          environments,
          enableMultiTenant,
          multiTenantCollection,
          userSettingsCollection,
          subTenantCollection,
          snippetCollectionName,
          snippetType,
        );

        editor.Popover.open({
          title: title,
          content: visibilityContent,
        })
          .getModel()
          .once('change:open', () => editor.stopCommand(this.id));
        selectedComponentAttrs = await handleVisibilityCondition(
          visibilityContent,
          selectedComponent,
          selectedComponentAttrs,
          projectId,
          crntVersion,
          collections,
          hasPageCollection,
          pageCollectionId,
          hasParentCMS,
          parentDataTable,
          parentDataGroup,
          enableMultiTenant,
          multiTenantCollection,
          userSettingsCollection,
          subTenantCollection,
          snippetCollectionName,
        );
      }
    },
    stop() {
      console.log('🚀 ~ file: configureEditorCommands.js:362 ~ STOP ~ tlb-setcompvisibility...');
    },
  });
}

async function addCompCodeCommand(commands, geditorBuilderOption, crntVersion) {
  const { projectId } = geditorBuilderOption || '';
  let name;
  let selectedRadioValue;
  let selectedComponentJSON;
  const appendToContent = (target, content) => {
    if (content instanceof HTMLElement) {
      target.appendChild(content);
    } else if (content) {
      target.insertAdjacentHTML('beforeend', content);
    }
  };
  commands.add('tlb-component-custom-code', {
    run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const target = this.target;

      if (target) {
        this.showCustomCode(target);
      }
    },

    stop(editor) {
      editor.Modal.close();
    },

    showCustomCode(target) {
      const { editor, options } = this;
      const title = 'Edit your code';
      const content = this.getContent();
      const code = target.toHTML();
      editor.Modal.open({ title, content })
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));
      this.getCodeViewer().setContent(code);
    },
    getPreContent() {},
    getPostContent() {},
    getContent() {
      const { editor } = this;
      const content = document.createElement('div');
      const codeViewer = this.getCodeViewer();
      const pfx = editor.getConfig('stylePrefix');
      content.className = `${pfx}custom-code`;
      appendToContent(content, this.getPreContent());
      content.appendChild(codeViewer.getElement());
      appendToContent(content, this.getPostContent());
      appendToContent(content, this.getSaveAsActions());
      appendToContent(content, this.getContentActions());
      codeViewer.refresh();
      setTimeout(() => codeViewer.focus(), 0);
      return content;
    },
    getContentActions() {
      const { editor } = this;
      const btnContainer = document.createElement('div');
      const btn = document.createElement('button');
      const pfx = editor.getConfig('stylePrefix');
      btnContainer.style = `position: absolute; bottom: 10px; right: 10px;`;
      btn.innerHTML = 'Update Code';
      btn.className = `${pfx}btn-prim ${pfx}btn-import__custom-code btn btn-theme-submit btn-sm mt-2`;
      btn.title = 'Update Code';
      btn.style = `float: right;`;
      btn.onclick = () => this.handleSave();
      btnContainer.appendChild(btn);
      return btnContainer;
    },
    getSaveAsActions() {
      const { editor } = this;
      const selectedComponent = editor.getSelected();
      selectedComponentJSON = selectedComponent.toJSON();

      const createButton = (label, className, onClick) => {
        const button = document.createElement('button');
        button.innerHTML = label;
        button.className = className;
        button.title = label;
        button.onclick = onClick;
        return button;
      };

      const hideElement = (element) => {
        element.style.display = 'none';
      };

      const showElement = (element) => {
        element.style.display = 'block';
      };

      const options = ['SNIPPET', 'CUSTOM_SEGMENT'];
      const saveAsGroup = document.createElement('div');

      const btn = createButton(
        'Save As',
        `${editor.getConfig('stylePrefix')}btn-prim ${editor.getConfig(
          'stylePrefix',
        )}btn-import__custom-code btn btn-theme-submit btn-sm mt-2`,
        () => {
          hideElement(btn);
          showElement(input);
          showElement(radioButtonsContainer);
          showElement(saveButtonContainer);
        },
      );

      const input = document.createElement('input');
      input.placeholder = 'Enter Name';
      input.className = 'form-control w-25 mt-3 mb-2';
      input.addEventListener('input', (e) => {
        name = e.target.value;
      });
      hideElement(input);

      const radioButtonsContainer = document.createElement('div');
      options.forEach((option) => {
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'options';
        radio.value = option;
        radio.addEventListener('change', (e) => {
          selectedRadioValue = e.target.value;
          radioButtonsContainer.querySelectorAll('input[type="radio"]').forEach((radio) => {
            const label = radio.nextElementSibling;
            const value = radio.value;
            label.classList.toggle('ml-1', value === selectedRadioValue);
            label.classList.toggle('label', value === selectedRadioValue);
            label.classList.toggle('badge-info', value === selectedRadioValue);
            label.classList.toggle('badge-pill', value === selectedRadioValue);
            label.classList.toggle('small', value === selectedRadioValue);
            label.classList.toggle('pl-2', value === selectedRadioValue);
            label.classList.toggle('px-3', value === selectedRadioValue);
          });
        });

        const label = document.createElement('label');
        label.innerHTML = this.transformOptionLabel(option);
        label.style.marginLeft = '4px';
        radioButtonsContainer.appendChild(radio);
        radioButtonsContainer.appendChild(label);
        const gap = document.createElement('span');
        gap.style.marginRight = '10px';
        radioButtonsContainer.appendChild(gap);
      });
      hideElement(radioButtonsContainer);

      const saveButtonContainer = document.createElement('div');
      const cancelButton = createButton(
        'Cancel',
        `${editor.getConfig('stylePrefix')}btn-prim ${editor.getConfig(
          'stylePrefix',
        )}btn-import__custom-code btn btn-theme-cancel btn-sm mt-2 mr-2`,
        () => {
          showElement(btn);
          hideElement(input);
          hideElement(radioButtonsContainer);
          hideElement(saveButtonContainer);
        },
      );
      const button = createButton(
        'Save',
        `${editor.getConfig('stylePrefix')}btn-prim ${editor.getConfig(
          'stylePrefix',
        )}btn-import__custom-code btn btn-theme-submit btn-sm mt-2`,
        () => this.handleSaveAs(),
      );
      saveButtonContainer.appendChild(cancelButton);
      saveButtonContainer.appendChild(button);
      hideElement(saveButtonContainer);

      saveAsGroup.appendChild(btn);
      saveAsGroup.appendChild(input);
      saveAsGroup.appendChild(radioButtonsContainer);
      saveAsGroup.appendChild(saveButtonContainer);

      return saveAsGroup;
    },
    transformOptionLabel(option) {
      return option
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },
    handleSave() {
      const { editor, target } = this;
      const code = this.getCodeViewer().getContent();
      target.replaceWith(code);
      editor.Modal.close();
      editor.selectRemove(target);
    },
    async handleSaveAs() {
      const { editor } = this;
      const code = this.getCodeViewer().getContent();
      const userIp = getCookie('userIp') || (await updateUserIpInCookie());
      const header = builderSurfaceJsonContentHeader(projectId, userIp);
      const content = {
        'nocode-html': code,
        'nocode-components': JSON.stringify([selectedComponentJSON]),
        'nocode-css': '* { box-sizing: border-box; } body {margin: 0;}',
      };
      const data = {
        name: name,
        projectId: projectId,
        snippetType: selectedRadioValue,
        version: crntVersion,
        content: content,
      };
      await axios
        .post(
          `${process.env.REACT_APP_BUILDER_ENGINE}v${crntVersion}/projects/${projectId}/snippet-templates`,
          data,
          header,
        )
        .then((res) => {
          console.log(res);
          editor.Modal.close();
          toast.success('Snippet Created Successfully !');
        })
        .catch((err) => {
          console.log(err);
          toast.error('All Fields are Mandatory !');
        });
    },
    getCodeViewer() {
      const { editor } = this;
      const codeViewOptions = {
        lineWrapping: false,
      };

      if (!this.codeViewer) {
        this.codeViewer = editor.CodeManager.createViewer({
          codeName: 'htmlmixed',
          theme: 'hopscotch',
          readOnly: 0,
          ...codeViewOptions,
        });
      }

      return this.codeViewer;
    },
    stop() {
      console.log('🚀 ~ file: configureEditorCommands.js:362 ~ STOP ~ tlb-compcustomcode...');
    },
  });
}

async function handleVisibilityCondition(
  visibilityContent,
  selectedComponent,
  selectedComponentAttrs,
  projectId,
  version,
  collections,
  hasPageCollection,
  pageCollectionId,
  hasParentCMS,
  parentDataTable,
  parentDataGroup,
  enableMultiTenant,
  multiTenantCollection,
  userSettingsCollection,
  subTenantCollection,
  snippetCollectionName,
) {
  const query = 'limit=20000';
  const userStatusElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__when-current-user',
  );
  const userStatusSelectElem = userStatusElem
    ? userStatusElem.querySelector('#gjs-sm-property-select__when-current-user')
    : '';
  const collectionFromElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__when-collection-from',
  );
  const collectionFromSelectElem = collectionFromElem
    ? collectionFromElem.querySelector('#gjs-sm-property-select__when-collection-from')
    : '';
  const collectionFromFieldElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__when-collection-field',
  );
  const collectionFromFieldSelectElem = collectionFromFieldElem
    ? collectionFromFieldElem.querySelector('#gjs-sm-property-select__when-collection-field')
    : '';
  const sourceFromBslElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__when-bsl',
  );
  const sourceFromBslSelectElem = sourceFromBslElem
    ? sourceFromBslElem.querySelector('#gjs-sm-property-select__when-bsl')
    : '';
  const sourceFromBslKeyElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__when-bsl-key',
  );
  const sourceFromBslKeyInputElem = sourceFromBslKeyElem
    ? sourceFromBslKeyElem.querySelector('#gjs-sm-property-input__when-bsl-key')
    : '';
  const whenConditionElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__when-condition',
  );
  const whenConditionSelectElem = whenConditionElem
    ? whenConditionElem.querySelector('#gjs-sm-property-select__when-condition')
    : '';
  const whenCollectionFieldValueElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__when-value',
  );
  const whenCollectionFieldValueSelectElem = whenCollectionFieldValueElem
    ? whenCollectionFieldValueElem.querySelector('#gjs-sm-property-select__when-value')
    : '';
  const whenCollectionFieldFixedValueElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__when-fixed-value',
  );
  const whenCollectionFieldFixedValueInputElem = whenCollectionFieldFixedValueElem
    ? whenCollectionFieldFixedValueElem.querySelector('#gjs-sm-property-input__when-fixed-value')
    : '';
  const whenBslFixedValueElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__when-bsl-fixed-value',
  );
  const whenBslFixedValueInputElem = whenBslFixedValueElem
    ? whenBslFixedValueElem.querySelector('#gjs-sm-property-input__when-bsl-fixed-value')
    : '';
  const thenConditionElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__then-comp-visibility',
  );
  const thenConditionSelectElem = thenConditionElem
    ? thenConditionElem.querySelector('#gjs-sm-property-select__then-comp-visibility')
    : '';
  const envConditionElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__env-bypass-comp-visibility',
  );
  const envConditionCheckboxElems = envConditionElem
    ? envConditionElem.querySelectorAll('input[type=checkbox]')
    : '';
  const thenAddClassVisibilityElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__then-add-class-comp-visibility',
  );
  const thenAddClassValueInputElem = thenAddClassVisibilityElem
    ? thenAddClassVisibilityElem.querySelector('#gjs-sm-property-input__then-add-class-value')
    : '';
  const thenRemoveClassVisibilityElem = visibilityContent.querySelector(
    '.gjs-sm-select.gjs-sm-property__then-remove-class-comp-visibility',
  );
  const thenRemoveClassValueInputElem = thenRemoveClassVisibilityElem
    ? thenRemoveClassVisibilityElem.querySelector('#gjs-sm-property-input__then-remove-class-value')
    : '';

  let visibilityDataObj = {};
  let whenSelectedCollection = '';
  let refCollectionName = '';
  let refCollectionField = '';

  let selectedVisConditionJson = selectedComponent.get('data-visibility-json');
  if (selectedVisConditionJson && Object.keys(selectedVisConditionJson).length) {
    visibilityDataObj = { ...selectedVisConditionJson };
  }

  if (userStatusElem) {
    let selectedVisUserStatusCondition = selectedComponent.get('visWhenUserStatus');

    if (selectedVisUserStatusCondition) {
      userStatusSelectElem.value = selectedVisUserStatusCondition;
    }

    userStatusSelectElem &&
      userStatusSelectElem.addEventListener('change', (ev) => {
        selectedComponentAttrs = selectedComponent.getAttributes();

        if (userStatusSelectElem.value) {
          visibilityDataObj['visWhenUserStatus'] = userStatusSelectElem.value;
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        } else {
          delete visibilityDataObj['visWhenUserStatus'];
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        }
        selectedComponent.set('visWhenUserStatus', userStatusSelectElem.value);

        if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
          selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
          selectedComponent.addAttributes(selectedComponentAttrs);
        } else {
          delete selectedComponentAttrs['data-vis-condition'];
          selectedComponent.setAttributes(selectedComponentAttrs);
        }
      });
  }

  if (collectionFromElem) {
    let selectedVisCollectionFrom = selectedComponent.get('visWhenCollectionFrom');

    if (selectedVisCollectionFrom) {
      collectionFromSelectElem.value = selectedVisCollectionFrom;
      switch (selectedVisCollectionFrom) {
        case 'BROWSER_STORAGE':
          {
            sourceFromBslElem.classList.remove('d-none');
            sourceFromBslKeyElem.classList.remove('d-none');
            whenBslFixedValueElem.classList.remove('d-none');
            collectionFromFieldElem.classList.add('d-none');
            whenCollectionFieldValueElem.classList.add('d-none');
            whenCollectionFieldFixedValueElem.classList.add('d-none');
          }
          break;
        default:
          sourceFromBslElem.classList.add('d-none');
          sourceFromBslKeyElem.classList.add('d-none');
          whenBslFixedValueElem.classList.add('d-none');
          collectionFromFieldElem.classList.remove('d-none');
          whenCollectionFieldValueElem.classList.remove('d-none');
          whenCollectionFieldFixedValueElem.classList.remove('d-none');
          break;
      }
    } else {
      sourceFromBslElem.classList.add('d-none');
      sourceFromBslKeyElem.classList.add('d-none');
      whenBslFixedValueElem.classList.add('d-none');
      whenCollectionFieldFixedValueElem.classList.remove('d-none');
    }

    collectionFromSelectElem &&
      collectionFromSelectElem.addEventListener('change', async (ev) => {
        selectedComponentAttrs = selectedComponent.getAttributes();
        if (collectionFromSelectElem.value) {
          visibilityDataObj['visWhenCollectionFrom'] = collectionFromSelectElem.value;

          //Set Selected Collection based on Collection From value
          let selectedVisCollectionFrom = collectionFromSelectElem.value;

          if (selectedVisCollectionFrom) {
            switch (selectedVisCollectionFrom) {
              case 'CURRENT_LOGGEDIN_USER':
                visibilityDataObj['visWhenCollection'] = 'user';
                const userCollection = collections.find(
                  (collection) => collection.collectionName === 'user',
                );
                whenSelectedCollection = userCollection ? { ...userCollection } : '';
                sourceFromBslElem.classList.add('d-none');
                sourceFromBslKeyElem.classList.add('d-none');
                whenBslFixedValueElem.classList.add('d-none');
                collectionFromFieldElem.classList.remove('d-none');
                whenCollectionFieldValueElem.classList.remove('d-none');
                whenCollectionFieldFixedValueElem.classList.remove('d-none');
                break;
              case 'CURRENT_LOGGEDIN_TENANT':
                if (enableMultiTenant) {
                  const { collectionName } = multiTenantCollection || '';
                  visibilityDataObj['visWhenCollection'] = collectionName;
                  whenSelectedCollection = multiTenantCollection
                    ? { ...multiTenantCollection }
                    : '';
                }
                sourceFromBslElem.classList.add('d-none');
                sourceFromBslKeyElem.classList.add('d-none');
                whenBslFixedValueElem.classList.add('d-none');
                collectionFromFieldElem.classList.remove('d-none');
                whenCollectionFieldValueElem.classList.remove('d-none');
                whenCollectionFieldFixedValueElem.classList.remove('d-none');
                break;
              case 'CURRENT_LOGGEDIN_USER_SETTINGS':
                if (enableMultiTenant) {
                  const { collectionName } = userSettingsCollection || '';
                  visibilityDataObj['visWhenCollection'] = collectionName;
                  whenSelectedCollection = userSettingsCollection
                    ? { ...userSettingsCollection }
                    : '';
                }
                sourceFromBslElem.classList.add('d-none');
                sourceFromBslKeyElem.classList.add('d-none');
                whenBslFixedValueElem.classList.add('d-none');
                collectionFromFieldElem.classList.remove('d-none');
                whenCollectionFieldValueElem.classList.remove('d-none');
                whenCollectionFieldFixedValueElem.classList.remove('d-none');
                break;
              case 'CURRENT_LOGGEDIN_SUB_TENANT':
                if (enableMultiTenant) {
                  const { collectionName } = subTenantCollection || '';
                  visibilityDataObj['visWhenCollection'] = collectionName;
                  whenSelectedCollection = subTenantCollection ? { ...subTenantCollection } : '';
                }
                sourceFromBslElem.classList.add('d-none');
                sourceFromBslKeyElem.classList.add('d-none');
                whenBslFixedValueElem.classList.add('d-none');
                collectionFromFieldElem.classList.remove('d-none');
                whenCollectionFieldValueElem.classList.remove('d-none');
                whenCollectionFieldFixedValueElem.classList.remove('d-none');
                break;
              case 'PAGE_COLLECTION':
                if (hasPageCollection) {
                  visibilityDataObj['visWhenCollection'] = pageCollectionId;
                  const pageCollection = pageCollectionId
                    ? collections.find(
                        (collection) => collection.collectionName === pageCollectionId,
                      )
                    : '';
                  whenSelectedCollection = pageCollection ? { ...pageCollection } : '';
                }
                sourceFromBslElem.classList.add('d-none');
                sourceFromBslKeyElem.classList.add('d-none');
                whenBslFixedValueElem.classList.add('d-none');
                collectionFromFieldElem.classList.remove('d-none');
                whenCollectionFieldValueElem.classList.remove('d-none');
                whenCollectionFieldFixedValueElem.classList.remove('d-none');
                break;
              case 'SNIPPET_COLLECTION':
                if (snippetCollectionName) {
                  visibilityDataObj['visWhenCollection'] = snippetCollectionName;
                  const snippetCollection = snippetCollectionName
                    ? collections.find(
                        (collection) => collection.collectionName === snippetCollectionName,
                      )
                    : '';
                  whenSelectedCollection = snippetCollection ? { ...snippetCollection } : '';
                }
                sourceFromBslElem.classList.add('d-none');
                sourceFromBslKeyElem.classList.add('d-none');
                whenBslFixedValueElem.classList.add('d-none');
                collectionFromFieldElem.classList.remove('d-none');
                whenCollectionFieldValueElem.classList.remove('d-none');
                whenCollectionFieldFixedValueElem.classList.remove('d-none');
                break;
              case 'PARENT_CMS_COMPONENT':
                if (hasParentCMS) {
                  let cmsCollectionName = '';
                  if (parentDataTable) {
                    cmsCollectionName = parentDataTable.attributes['collectionName'];
                  } else if (parentDataGroup) {
                    cmsCollectionName = parentDataGroup.attributes['collectionName'];
                  }
                  visibilityDataObj['visWhenCollection'] = cmsCollectionName;
                  const cmsCollection = cmsCollectionName
                    ? collections.find(
                        (collection) => collection.collectionName === cmsCollectionName,
                      )
                    : '';
                  whenSelectedCollection = cmsCollection ? { ...cmsCollection } : '';
                }
                sourceFromBslElem.classList.add('d-none');
                sourceFromBslKeyElem.classList.add('d-none');
                whenBslFixedValueElem.classList.add('d-none');
                collectionFromFieldElem.classList.remove('d-none');
                whenCollectionFieldValueElem.classList.remove('d-none');
                whenCollectionFieldFixedValueElem.classList.remove('d-none');
                break;
              case 'BROWSER_STORAGE':
                {
                  visibilityDataObj['visWhenCollection'] = 'BROWSER_STORAGE';
                  // delete visibilityDataObj['visWhenCollection'];
                  whenSelectedCollection = '';
                  sourceFromBslElem.classList.remove('d-none');
                  sourceFromBslKeyElem.classList.remove('d-none');
                  whenBslFixedValueElem.classList.remove('d-none');
                  collectionFromFieldElem.classList.add('d-none');
                  whenCollectionFieldValueElem.classList.add('d-none');
                  whenCollectionFieldFixedValueElem.classList.add('d-none');
                }
                break;
              default:
                sourceFromBslElem.classList.add('d-none');
                sourceFromBslKeyElem.classList.add('d-none');
                whenBslFixedValueElem.classList.add('d-none');
                collectionFromFieldElem.classList.remove('d-none');
                whenCollectionFieldValueElem.classList.remove('d-none');
                whenCollectionFieldFixedValueElem.classList.remove('d-none');
                break;
            }
          }

          selectedComponent.set('data-visibility-json', visibilityDataObj);

          if (whenSelectedCollection) {
            if (collectionFromFieldSelectElem) {
              let optionHtml = `<option value="">- Select One -</option>`;

              const nestedFields = await getInnerFieldOptions(
                whenSelectedCollection.fields,
                projectId,
                collections,
              );
              const allowedNestedFields = nestedFields.filter((field) => {
                return VISIBILITY_SUPPORTED_FIELD_TYPES.includes(
                  field.metaData ? JSON.parse(field.metaData).fieldType : '',
                );
              });

              optionHtml += `${whenSelectedCollection.fields
                .filter((field) => {
                  return VISIBILITY_SUPPORTED_FIELD_TYPES.includes(field.type);
                })
                .map(
                  (field) =>
                    `<option value="${field.fieldName}">${field.fieldTitle.en} (${getFieldTypeName(
                      field.type,
                    )})</option>`,
                )
                .join('')}`;
              optionHtml += `<option value="">------</option>`;
              optionHtml += `${allowedNestedFields
                .map(
                  (field) =>
                    `<option value="${field.id}">${field.name} (${getFieldTypeName(
                      JSON.parse(field.metaData).fieldType,
                    )})</option>`,
                )
                .join('')}`;
              collectionFromFieldSelectElem.innerHTML = optionHtml;
            }
          }
        } else {
          delete visibilityDataObj['visWhenCollectionFrom'];
          delete visibilityDataObj['visWhenCollection'];
          delete visibilityDataObj['visWhenCollectionField'];
          delete visibilityDataObj['visWhenCollectionFieldType'];
          delete visibilityDataObj['visWhenCollectionFieldValue'];
          delete visibilityDataObj['visWhenCollectionFieldFixedValue'];
          delete visibilityDataObj['visWhenBsl'];
          delete visibilityDataObj['visWhenBslKey'];
          delete visibilityDataObj['visWhenBslFixedValue'];
          delete visibilityDataObj['visWhenCondition'];

          let optionHtml = `<option value="">- Select One -</option>`;
          collectionFromFieldSelectElem.innerHTML = optionHtml;
          whenCollectionFieldValueSelectElem.innerHTML = optionHtml;
          whenConditionSelectElem.value = '';
          collectionFromFieldSelectElem.value = '';
          whenCollectionFieldValueSelectElem.value = '';
          whenCollectionFieldFixedValueInputElem.value = '';

          sourceFromBslSelectElem.value = '';
          sourceFromBslKeyInputElem.value = '';
          whenBslFixedValueInputElem.value = '';
          sourceFromBslElem.classList.add('d-none');
          sourceFromBslKeyElem.classList.add('d-none');
          whenBslFixedValueElem.classList.add('d-none');
          collectionFromFieldElem.classList.remove('d-none');
          whenCollectionFieldValueElem.classList.remove('d-none');
          whenCollectionFieldFixedValueElem.classList.remove('d-none');
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        }
        selectedComponent.set('visWhenCollectionFrom', collectionFromSelectElem.value);
        if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
          selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
          selectedComponent.addAttributes(selectedComponentAttrs);
        } else {
          delete selectedComponentAttrs['data-vis-condition'];
          selectedComponent.setAttributes(selectedComponentAttrs);
        }
      });
  } else {
    sourceFromBslElem.classList.add('d-none');
    sourceFromBslKeyElem.classList.add('d-none');
    whenBslFixedValueElem.classList.add('d-none');
    collectionFromFieldElem.classList.remove('d-none');
    whenCollectionFieldFixedValueElem.classList.remove('d-none');
  }

  if (collectionFromFieldElem) {
    let selectedVisCollectionField = selectedComponent.get('visWhenCollectionField');
    let collectionItems = '';
    if (selectedVisCollectionField) {
      let selectedVisWhenCollectionName = visibilityDataObj['visWhenCollection'];
      whenSelectedCollection = collections.find(
        (collection) => collection.collectionName === selectedVisWhenCollectionName,
      );
      let selectedVisWhenCollectionField = '';
      if (whenSelectedCollection) {
        const nestedFields = await getInnerFieldOptions(
          whenSelectedCollection.fields,
          projectId,
          collections,
        );
        const allowedNestedFields = nestedFields.filter((field) => {
          return VISIBILITY_SUPPORTED_FIELD_TYPES.includes(
            field.metaData ? JSON.parse(field.metaData).fieldType : '',
          );
        });
        if (collectionFromFieldSelectElem) {
          let optionHtml = `<option value="">- Select One -</option>`;
          optionHtml += `${whenSelectedCollection.fields
            .filter((field) => {
              return VISIBILITY_SUPPORTED_FIELD_TYPES.includes(field.type);
            })
            .map(
              (field) =>
                `<option value="${field.fieldName}">${field.fieldTitle.en} (${getFieldTypeName(
                  field.type,
                )})</option>`,
            )
            .join('')}`;
          optionHtml += `<option value="">------</option>`;
          optionHtml += `${allowedNestedFields
            .map(
              (field) =>
                `<option value="${field.id}">${field.name} (${getFieldTypeName(
                  JSON.parse(field.metaData).fieldType,
                )})</option>`,
            )
            .join('')}`;
          collectionFromFieldSelectElem.innerHTML = optionHtml;

          selectedVisWhenCollectionField = whenSelectedCollection.fields
            .filter((field) => {
              return VISIBILITY_SUPPORTED_FIELD_TYPES.includes(field.type);
            })
            .find((field) => field.fieldName === selectedVisCollectionField);
        }
      }

      collectionFromFieldSelectElem.value = selectedVisCollectionField;

      if (selectedVisCollectionField) {
        if (selectedVisCollectionField.includes('.')) {
          whenCollectionFieldValueSelectElem.value = '';
          whenCollectionFieldValueSelectElem.setAttribute('disabled', true);
        }
      }

      if (
        selectedVisWhenCollectionField &&
        selectedVisWhenCollectionField.type === 'static_option'
      ) {
        collectionItems = selectedVisWhenCollectionField.staticOptions.length
          ? [...selectedVisWhenCollectionField.staticOptions]
          : '';
      } else if (
        selectedVisWhenCollectionField &&
        selectedVisWhenCollectionField.type === 'dynamic_option'
      ) {
        const { refCollection } = selectedVisWhenCollectionField
          ? selectedVisWhenCollectionField
          : '';
        const { collectionName, collectionField } = refCollection ? refCollection : '';

        refCollectionName = collectionName;
        refCollectionField = collectionField;

        collectionItems =
          refCollectionName && refCollectionName !== 'BROWSER_STORAGE'
            ? await loadCollectionItems(projectId, version, refCollectionName, query)
            : '';
      } else {
        collectionItems =
          selectedVisWhenCollectionName && selectedVisWhenCollectionName !== 'BROWSER_STORAGE'
            ? await loadCollectionItems(projectId, version, selectedVisWhenCollectionName, query)
            : '';
      }
      selectedComponent.set('data-visibility-json', visibilityDataObj);
      if (selectedVisWhenCollectionName && collectionItems) {
        if (
          selectedVisWhenCollectionField &&
          selectedVisWhenCollectionField.type === 'static_option'
        ) {
          if (selectedVisCollectionField) {
            let collectionFieldItemSet = new Set();
            collectionItems.map((item) => {
              let itemValue = item;
              if (itemValue && typeof itemValue !== 'undefined') {
                if (itemValue && Array.isArray(itemValue)) {
                  itemValue = itemValue.toString();
                }
                collectionFieldItemSet.add(itemValue);
              }
            });

            let optionHtml = `<option value="">- Select One -</option>`;
            `${collectionFieldItemSet.forEach((item) => {
              optionHtml += `<option value="${item}">${item}</option>`;
            })}`;
            whenCollectionFieldValueSelectElem.innerHTML = optionHtml;
          }
        } else if (
          selectedVisWhenCollectionField &&
          selectedVisWhenCollectionField.type === 'dynamic_option' &&
          Object.keys(collectionItems).length
        ) {
          if (refCollectionField) {
            let collectionFieldItemSet = new Set();
            collectionItems.map((item) => {
              let itemValue = item[refCollectionField];
              if (itemValue && typeof itemValue !== 'undefined') {
                if (itemValue && Array.isArray(itemValue)) {
                  itemValue = itemValue.toString();
                }
                collectionFieldItemSet.add(itemValue);
              }
            });
            let optionHtml = `<option value="">- Select One -</option>`;
            `${collectionFieldItemSet.forEach((item) => {
              optionHtml += `<option value="${item}">${item}</option>`;
            })}`;
            whenCollectionFieldValueSelectElem.innerHTML = optionHtml;
          }
        } else if (Object.keys(collectionItems).length) {
          if (selectedVisCollectionField) {
            let collectionFieldItemSet = new Set();
            collectionItems.map((item) => {
              let itemValue = item[selectedVisCollectionField];
              if (itemValue && typeof itemValue !== 'undefined') {
                if (itemValue && Array.isArray(itemValue)) {
                  itemValue = itemValue.toString();
                }
                collectionFieldItemSet.add(itemValue);
              }
            });

            let optionHtml = `<option value="">- Select One -</option>`;
            `${collectionFieldItemSet.forEach((item) => {
              optionHtml += `<option value="${item}">${item}</option>`;
            })}`;
            whenCollectionFieldValueSelectElem.innerHTML = optionHtml;
          }
        }
      }
    }

    collectionFromFieldSelectElem &&
      collectionFromFieldSelectElem.addEventListener('change', async (ev) => {
        selectedComponentAttrs = selectedComponent.getAttributes();
        if (collectionFromFieldSelectElem.value) {
          visibilityDataObj['visWhenCollectionField'] = collectionFromFieldSelectElem.value;
          let whenSelectedCollectionField = whenSelectedCollection.fields
            .filter((field) => {
              return VISIBILITY_SUPPORTED_FIELD_TYPES.includes(field.type);
            })
            .find((field) => field.fieldName === collectionFromFieldSelectElem.value);
          if (whenSelectedCollectionField) {
            visibilityDataObj['visWhenCollectionFieldType'] = whenSelectedCollectionField.type;
          } else {
            if (
              collectionFromFieldSelectElem.value &&
              collectionFromFieldSelectElem.value.includes('.')
            ) {
              const nestedField = await getInnerFieldOptions(
                whenSelectedCollection.fields,
                projectId,
                collections,
              );
              const selectedNestedField = nestedField.find(
                (field) => field.id === collectionFromFieldSelectElem.value,
              );
              visibilityDataObj['visWhenCollectionFieldType'] = JSON.parse(
                selectedNestedField.metaData,
              ).fieldType;
            }
          }

          const whenSelectedCollectionName = visibilityDataObj['visWhenCollection'];

          if (whenSelectedCollectionField && whenSelectedCollectionField.type === 'static_option') {
            collectionItems = whenSelectedCollectionField.staticOptions.length
              ? [...whenSelectedCollectionField.staticOptions]
              : '';
          } else if (
            whenSelectedCollectionField &&
            whenSelectedCollectionField.type === 'dynamic_option'
          ) {
            const { refCollection } = whenSelectedCollectionField
              ? whenSelectedCollectionField
              : '';
            const { collectionName, collectionField } = refCollection ? refCollection : '';

            refCollectionName = collectionName;
            refCollectionField = collectionField;

            collectionItems = refCollectionName
              ? await loadCollectionItems(projectId, version, refCollectionName, query)
              : '';
          } else {
            collectionItems = whenSelectedCollectionName
              ? await loadCollectionItems(projectId, version, whenSelectedCollectionName, query)
              : '';
          }
          selectedComponent.set('data-visibility-json', visibilityDataObj);

          if (whenSelectedCollectionName && collectionItems) {
            if (
              whenSelectedCollectionField &&
              whenSelectedCollectionField.type === 'static_option'
            ) {
              if (whenCollectionFieldValueSelectElem) {
                let collectionFieldItemSet = new Set();
                collectionItems.map((item) => {
                  let itemValue = item;
                  if (itemValue && typeof itemValue !== 'undefined') {
                    if (itemValue && Array.isArray(itemValue)) {
                      itemValue = itemValue.toString();
                    }
                    collectionFieldItemSet.add(itemValue);
                  }
                });
                let optionHtml = `<option value="">- Select One -</option>`;
                `${collectionFieldItemSet.forEach((item) => {
                  optionHtml += `<option value="${item}">${item}</option>`;
                })}`;
                whenCollectionFieldValueSelectElem.innerHTML = optionHtml;
              }
            } else if (
              whenSelectedCollectionField &&
              whenSelectedCollectionField.type === 'dynamic_option' &&
              Object.keys(collectionItems).length
            ) {
              if (whenCollectionFieldValueSelectElem && refCollectionField) {
                let collectionFieldItemSet = new Set();
                collectionItems.map((item) => {
                  let itemValue = item[refCollectionField];
                  if (itemValue && typeof itemValue !== 'undefined') {
                    if (itemValue && Array.isArray(itemValue)) {
                      itemValue = itemValue.toString();
                    }
                    collectionFieldItemSet.add(itemValue);
                  }
                });
                let optionHtml = `<option value="">- Select One -</option>`;
                `${collectionFieldItemSet.forEach((item) => {
                  optionHtml += `<option value="${item}">${item}</option>`;
                })}`;
                whenCollectionFieldValueSelectElem.innerHTML = optionHtml;
              }
            } else if (Object.keys(collectionItems).length) {
              if (whenCollectionFieldValueSelectElem) {
                let collectionFieldItemSet = new Set();
                collectionItems.map((item) => {
                  let itemValue = item[collectionFromFieldSelectElem.value];
                  if (itemValue && typeof itemValue !== 'undefined') {
                    if (itemValue && Array.isArray(itemValue)) {
                      itemValue = itemValue.toString();
                    }
                    collectionFieldItemSet.add(itemValue);
                  }
                });
                let optionHtml = `<option value="">- Select One -</option>`;
                `${collectionFieldItemSet.forEach((item) => {
                  optionHtml += `<option value="${item}">${item}</option>`;
                })}`;
                whenCollectionFieldValueSelectElem.innerHTML = optionHtml;
              }
            }
          }
        } else {
          delete visibilityDataObj['visWhenCollectionField'];
          delete visibilityDataObj['visWhenCollectionFieldType'];
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        }

        selectedComponent.set('visWhenCollectionField', collectionFromFieldSelectElem.value);

        if (
          collectionFromFieldSelectElem.value &&
          collectionFromFieldSelectElem.value.includes('.')
        ) {
          whenCollectionFieldValueSelectElem.setAttribute('disabled', true);
        } else {
          if (whenCollectionFieldValueSelectElem.hasAttribute('disabled')) {
            whenCollectionFieldValueSelectElem.removeAttribute('disabled');
          }
        }

        if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
          selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
          selectedComponent.addAttributes(selectedComponentAttrs);
        } else {
          delete selectedComponentAttrs['data-vis-condition'];
          selectedComponent.setAttributes(selectedComponentAttrs);
        }
      });
  }

  if (whenConditionElem) {
    let selectedVisCondition = selectedComponent.get('visWhenCondition');

    if (selectedVisCondition) {
      whenConditionSelectElem.value = selectedVisCondition;

      if (
        ['IS_NULL', 'IS_NOT_NULL', 'IS_BOOLEAN_TRUE', 'IS_BOOLEAN_FALSE'].includes(
          selectedVisCondition,
        )
      ) {
        whenCollectionFieldValueSelectElem.setAttribute('disabled', true);
        whenCollectionFieldFixedValueInputElem.setAttribute('disabled', true);
        whenBslFixedValueElem.setAttribute('disabled', true);
        whenBslFixedValueInputElem.setAttribute('disabled', true);
        whenCollectionFieldValueElem.classList.add('invisible');
        whenCollectionFieldFixedValueElem.classList.add('invisible');
        whenBslFixedValueElem.classList.add('invisible');
        whenBslFixedValueInputElem.classList.add('invisible');
        whenBslFixedValueElem.classList.add('invisible');
        whenBslFixedValueInputElem.classList.add('invisible');
      } else {
        if (whenCollectionFieldValueSelectElem.hasAttribute('disabled')) {
          whenCollectionFieldValueSelectElem.removeAttribute('disabled');
          whenCollectionFieldValueElem.classList.remove('invisible');
        }
        if (whenCollectionFieldFixedValueInputElem.hasAttribute('disabled')) {
          whenCollectionFieldFixedValueInputElem.removeAttribute('disabled');
          whenCollectionFieldFixedValueElem.classList.remove('invisible');
        }
        if (whenBslFixedValueElem.hasAttribute('disabled')) {
          whenBslFixedValueElem.removeAttribute('disabled');
          whenBslFixedValueElem.classList.remove('invisible');
        }
        if (whenBslFixedValueInputElem.hasAttribute('disabled')) {
          whenBslFixedValueInputElem.removeAttribute('disabled');
          whenBslFixedValueInputElem.classList.remove('invisible');
        }
      }
    } else {
      if (whenCollectionFieldValueSelectElem.hasAttribute('disabled')) {
        whenCollectionFieldValueSelectElem.removeAttribute('disabled');
        whenCollectionFieldValueElem.classList.remove('invisible');
      }
      if (whenCollectionFieldFixedValueInputElem.hasAttribute('disabled')) {
        whenCollectionFieldFixedValueInputElem.removeAttribute('disabled');
        whenCollectionFieldFixedValueElem.classList.remove('invisible');
      }
      if (whenBslFixedValueElem.hasAttribute('disabled')) {
        whenBslFixedValueElem.removeAttribute('disabled');
        whenBslFixedValueElem.classList.remove('invisible');
      }
      if (whenBslFixedValueInputElem.hasAttribute('disabled')) {
        whenBslFixedValueInputElem.removeAttribute('disabled');
        whenBslFixedValueInputElem.classList.remove('invisible');
      }
    }

    if (collectionFromFieldSelectElem.value && collectionFromFieldSelectElem.value.includes('.')) {
      whenCollectionFieldValueSelectElem.setAttribute('disabled', true);
    }

    whenConditionSelectElem &&
      whenConditionSelectElem.addEventListener('change', (ev) => {
        selectedComponentAttrs = selectedComponent.getAttributes();

        if (whenConditionSelectElem.value) {
          visibilityDataObj['visWhenCondition'] = whenConditionSelectElem.value;
          selectedComponent.set('data-visibility-json', visibilityDataObj);
          if (
            ['IS_NULL', 'IS_NOT_NULL', 'IS_BOOLEAN_TRUE', 'IS_BOOLEAN_FALSE'].includes(
              whenConditionSelectElem.value,
            )
          ) {
            whenCollectionFieldValueSelectElem.setAttribute('disabled', true);
            whenCollectionFieldFixedValueInputElem.setAttribute('disabled', true);
            whenBslFixedValueElem.setAttribute('disabled', true);
            whenBslFixedValueInputElem.setAttribute('disabled', true);
            whenCollectionFieldValueElem.classList.add('invisible');
            whenCollectionFieldFixedValueElem.classList.add('invisible');
            whenBslFixedValueElem.classList.add('invisible');
            whenBslFixedValueInputElem.classList.add('invisible');
            whenBslFixedValueElem.classList.add('invisible');
            whenBslFixedValueInputElem.classList.add('invisible');
          } else {
            if (
              collectionFromFieldSelectElem.value &&
              collectionFromFieldSelectElem.value.includes('.')
            ) {
              if (whenCollectionFieldValueSelectElem.hasAttribute('disabled')) {
                whenCollectionFieldValueElem.classList.remove('invisible');
              }
            } else {
              if (whenCollectionFieldValueSelectElem.hasAttribute('disabled')) {
                whenCollectionFieldValueSelectElem.removeAttribute('disabled');
                whenCollectionFieldValueElem.classList.remove('invisible');
              }
            }
            if (whenCollectionFieldFixedValueInputElem.hasAttribute('disabled')) {
              whenCollectionFieldFixedValueInputElem.removeAttribute('disabled');
              whenCollectionFieldFixedValueElem.classList.remove('invisible');
            }
            if (whenBslFixedValueElem.hasAttribute('disabled')) {
              whenBslFixedValueElem.removeAttribute('disabled');
              whenBslFixedValueElem.classList.remove('invisible');
            }
            if (whenBslFixedValueInputElem.hasAttribute('disabled')) {
              whenBslFixedValueInputElem.removeAttribute('disabled');
              whenBslFixedValueInputElem.classList.remove('invisible');
            }
          }
        } else {
          if (
            collectionFromFieldSelectElem.value &&
            collectionFromFieldSelectElem.value.includes('.')
          ) {
            if (whenCollectionFieldValueSelectElem.hasAttribute('disabled')) {
              whenCollectionFieldValueElem.classList.remove('invisible');
            }
          } else {
            if (whenCollectionFieldValueSelectElem.hasAttribute('disabled')) {
              whenCollectionFieldValueSelectElem.removeAttribute('disabled');
              whenCollectionFieldValueElem.classList.remove('invisible');
            }
          }
          if (whenCollectionFieldFixedValueInputElem.hasAttribute('disabled')) {
            whenCollectionFieldFixedValueInputElem.removeAttribute('disabled');
            whenCollectionFieldFixedValueElem.classList.remove('invisible');
          }
          if (whenBslFixedValueElem.hasAttribute('disabled')) {
            whenBslFixedValueElem.removeAttribute('disabled');
            whenBslFixedValueElem.classList.remove('invisible');
          }
          if (whenBslFixedValueInputElem.hasAttribute('disabled')) {
            whenBslFixedValueInputElem.removeAttribute('disabled');
            whenBslFixedValueInputElem.classList.remove('invisible');
          }
          delete visibilityDataObj['visWhenCondition'];
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        }
        selectedComponent.set('visWhenCondition', whenConditionSelectElem.value);
        if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
          selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
          selectedComponent.addAttributes(selectedComponentAttrs);
        } else {
          delete selectedComponentAttrs['data-vis-condition'];
          selectedComponent.setAttributes(selectedComponentAttrs);
        }
      });
  }

  if (sourceFromBslElem) {
    let selectedVisBsl = selectedComponent.get('visWhenBsl');

    if (selectedVisBsl) {
      sourceFromBslSelectElem.value = selectedVisBsl;
    }

    sourceFromBslSelectElem &&
      sourceFromBslSelectElem.addEventListener('change', (ev) => {
        selectedComponentAttrs = selectedComponent.getAttributes();

        if (sourceFromBslSelectElem.value) {
          visibilityDataObj['visWhenBsl'] = sourceFromBslSelectElem.value;
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        } else {
          delete visibilityDataObj['visWhenBsl'];
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        }
        selectedComponent.set('visWhenBsl', sourceFromBslSelectElem.value);
        if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
          selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
          selectedComponent.addAttributes(selectedComponentAttrs);
        } else {
          delete selectedComponentAttrs['data-vis-condition'];
          selectedComponent.setAttributes(selectedComponentAttrs);
        }
      });
  }

  if (sourceFromBslKeyElem) {
    let selectedVisWhenBslKey = selectedComponent.get('visWhenBslKey');

    if (selectedVisWhenBslKey) {
      sourceFromBslKeyInputElem.value = selectedVisWhenBslKey;
      whenCollectionFieldValueSelectElem.setAttribute('disabled', true);
    }

    sourceFromBslKeyInputElem &&
      sourceFromBslKeyInputElem.addEventListener('change', (ev) => {
        selectedComponentAttrs = selectedComponent.getAttributes();

        if (sourceFromBslKeyInputElem.value) {
          visibilityDataObj['visWhenBslKey'] = sourceFromBslKeyInputElem.value;
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        } else {
          delete visibilityDataObj['visWhenBslKey'];
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        }
        selectedComponent.set('visWhenBslKey', sourceFromBslKeyInputElem.value);

        if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
          selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
          selectedComponent.addAttributes(selectedComponentAttrs);
        } else {
          delete selectedComponentAttrs['data-vis-condition'];
          selectedComponent.setAttributes(selectedComponentAttrs);
        }
      });
  }

  if (whenCollectionFieldValueElem) {
    let selectedVisCollectionFieldValue = selectedComponent.get('visWhenCollectionFieldValue');

    if (selectedVisCollectionFieldValue) {
      whenCollectionFieldValueSelectElem.value = selectedVisCollectionFieldValue;
      whenCollectionFieldFixedValueInputElem.setAttribute('disabled', true);
    }

    whenCollectionFieldValueSelectElem &&
      whenCollectionFieldValueSelectElem.addEventListener('change', (ev) => {
        selectedComponentAttrs = selectedComponent.getAttributes();

        if (whenCollectionFieldValueSelectElem.value) {
          visibilityDataObj['visWhenCollectionFieldValue'] =
            whenCollectionFieldValueSelectElem.value;
          delete visibilityDataObj['visWhenCollectionFieldFixedValue'];
          whenCollectionFieldFixedValueInputElem.value = '';
          whenCollectionFieldFixedValueInputElem.setAttribute('disabled', true);
          selectedComponent.set('visWhenCollectionFieldFixedValue', '');
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        } else {
          delete visibilityDataObj['visWhenCollectionFieldValue'];
          whenCollectionFieldFixedValueInputElem.removeAttribute('disabled');
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        }
        selectedComponent.set(
          'visWhenCollectionFieldValue',
          whenCollectionFieldValueSelectElem.value,
        );
        if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
          selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
          selectedComponent.addAttributes(selectedComponentAttrs);
        } else {
          delete selectedComponentAttrs['data-vis-condition'];
          selectedComponent.setAttributes(selectedComponentAttrs);
        }
      });
  }

  if (whenCollectionFieldFixedValueElem) {
    let selectedVisWhenCollectionFieldFixedValue = selectedComponent.get(
      'visWhenCollectionFieldFixedValue',
    );

    if (selectedVisWhenCollectionFieldFixedValue) {
      whenCollectionFieldFixedValueInputElem.value = selectedVisWhenCollectionFieldFixedValue;
      whenCollectionFieldValueSelectElem.setAttribute('disabled', true);
    }

    whenCollectionFieldFixedValueInputElem &&
      whenCollectionFieldFixedValueInputElem.addEventListener('change', (ev) => {
        selectedComponentAttrs = selectedComponent.getAttributes();

        if (whenCollectionFieldFixedValueInputElem.value) {
          visibilityDataObj['visWhenCollectionFieldFixedValue'] =
            whenCollectionFieldFixedValueInputElem.value;
          delete visibilityDataObj['visWhenCollectionFieldValue'];
          whenCollectionFieldValueSelectElem.value = '';
          whenCollectionFieldValueSelectElem.setAttribute('disabled', true);
          selectedComponent.set('visWhenCollectionFieldValue', '');
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        } else {
          delete visibilityDataObj['visWhenCollectionFieldFixedValue'];

          if (
            !(
              collectionFromFieldSelectElem.value &&
              collectionFromFieldSelectElem.value.includes('.')
            )
          ) {
            whenCollectionFieldValueSelectElem.removeAttribute('disabled');
          }
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        }
        selectedComponent.set(
          'visWhenCollectionFieldFixedValue',
          whenCollectionFieldFixedValueInputElem.value,
        );

        if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
          selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
          selectedComponent.addAttributes(selectedComponentAttrs);
        } else {
          delete selectedComponentAttrs['data-vis-condition'];
          selectedComponent.setAttributes(selectedComponentAttrs);
        }
      });
  }

  if (whenBslFixedValueElem) {
    let selectedVisWhenBslFixedValue = selectedComponent.get('visWhenBslFixedValue');

    if (selectedVisWhenBslFixedValue) {
      whenBslFixedValueInputElem.value = selectedVisWhenBslFixedValue;
    }

    whenBslFixedValueInputElem &&
      whenBslFixedValueInputElem.addEventListener('change', (ev) => {
        selectedComponentAttrs = selectedComponent.getAttributes();

        if (whenBslFixedValueInputElem.value) {
          visibilityDataObj['visWhenBslFixedValue'] = whenBslFixedValueInputElem.value;
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        } else {
          delete visibilityDataObj['visWhenBslFixedValue'];
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        }
        selectedComponent.set('visWhenBslFixedValue', whenBslFixedValueInputElem.value);

        if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
          selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
          selectedComponent.addAttributes(selectedComponentAttrs);
        } else {
          delete selectedComponentAttrs['data-vis-condition'];
          selectedComponent.setAttributes(selectedComponentAttrs);
        }
      });
  }

  if (thenConditionElem) {
    let selectedVisThenCondition = selectedComponent.get('visThenCondition');

    if (selectedVisThenCondition) {
      thenConditionSelectElem.value = selectedVisThenCondition;
    }

    thenConditionSelectElem &&
      thenConditionSelectElem.addEventListener('change', (ev) => {
        selectedComponentAttrs = selectedComponent.getAttributes();

        if (thenConditionSelectElem.value) {
          visibilityDataObj['visThenCondition'] = thenConditionSelectElem.value;
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        } else {
          delete visibilityDataObj['visThenCondition'];
          selectedComponent.set('data-visibility-json', visibilityDataObj);
        }
        selectedComponent.set('visThenCondition', thenConditionSelectElem.value);

        if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
          selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
          selectedComponent.addAttributes(selectedComponentAttrs);
        } else {
          delete selectedComponentAttrs['data-vis-condition'];
          selectedComponent.setAttributes(selectedComponentAttrs);
        }
      });

    if (thenAddClassValueInputElem) {
      let selectedVisThenAddClassValue = selectedComponent.get('visThenAddClass');

      if (selectedVisThenAddClassValue) {
        thenAddClassValueInputElem.value = selectedVisThenAddClassValue;
      }

      thenAddClassValueInputElem &&
        thenAddClassValueInputElem.addEventListener('change', (ev) => {
          selectedComponentAttrs = selectedComponent.getAttributes();

          if (thenAddClassValueInputElem.value) {
            visibilityDataObj['visThenAddClass'] = thenAddClassValueInputElem.value;
            selectedComponent.set('data-visibility-json', visibilityDataObj);
          } else {
            delete visibilityDataObj['visThenAddClass'];
            selectedComponent.set('data-visibility-json', visibilityDataObj);
          }
          selectedComponent.set('visThenAddClass', thenAddClassValueInputElem.value);

          if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
            selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
            selectedComponent.addAttributes(selectedComponentAttrs);
          } else {
            delete selectedComponentAttrs['data-vis-condition'];
            selectedComponent.setAttributes(selectedComponentAttrs);
          }
        });
    }

    if (thenRemoveClassValueInputElem) {
      let selectedVisThenRemoveClassValue = selectedComponent.get('visThenRemoveClass');

      if (selectedVisThenRemoveClassValue) {
        thenRemoveClassValueInputElem.value = selectedVisThenRemoveClassValue;
      }

      thenRemoveClassValueInputElem &&
        thenRemoveClassValueInputElem.addEventListener('change', (ev) => {
          selectedComponentAttrs = selectedComponent.getAttributes();

          if (thenRemoveClassValueInputElem.value) {
            visibilityDataObj['visThenRemoveClass'] = thenRemoveClassValueInputElem.value;
            selectedComponent.set('data-visibility-json', visibilityDataObj);
          } else {
            delete visibilityDataObj['visThenRemoveClass'];
            selectedComponent.set('data-visibility-json', visibilityDataObj);
          }
          selectedComponent.set('visThenRemoveClass', thenRemoveClassValueInputElem.value);

          if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
            selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
            selectedComponent.addAttributes(selectedComponentAttrs);
          } else {
            delete selectedComponentAttrs['data-vis-condition'];
            selectedComponent.setAttributes(selectedComponentAttrs);
          }
        });
    }
  }

  if (envConditionElem) {
    let selectedVisEnvHideArr = selectedComponent.get('visEnvHide');

    if (selectedVisEnvHideArr && selectedVisEnvHideArr.length) {
      selectedVisEnvHideArr.forEach((selectedVisEnvHide) => {
        let envCheckboxElem = envConditionElem.querySelector(
          `input#${selectedVisEnvHide}[type=checkbox]`,
        );

        if (envCheckboxElem) envCheckboxElem.checked = true;
      });
    }

    let hideOnEnvironments =
      selectedVisEnvHideArr && selectedVisEnvHideArr.length ? selectedVisEnvHideArr : [];

    envConditionCheckboxElems &&
      envConditionCheckboxElems.forEach((envConditionCheckboxElem) => {
        envConditionCheckboxElem.addEventListener('click', (ev) => {
          let checkboxValue = envConditionCheckboxElem.value;
          if (ev.target.checked) {
            hideOnEnvironments.push(checkboxValue);
          } else {
            hideOnEnvironments =
              hideOnEnvironments &&
              hideOnEnvironments.filter(function (item) {
                return item !== checkboxValue;
              });
          }

          selectedComponentAttrs = selectedComponent.getAttributes();

          if (hideOnEnvironments && hideOnEnvironments.length) {
            visibilityDataObj['visEnvHide'] = hideOnEnvironments;
            selectedComponent.set('data-visibility-json', visibilityDataObj);
          } else {
            delete visibilityDataObj['visEnvHide'];
            selectedComponent.set('data-visibility-json', visibilityDataObj);
          }
          selectedComponent.set('visEnvHide', hideOnEnvironments);

          if (visibilityDataObj && Object.keys(visibilityDataObj).length) {
            selectedComponentAttrs['data-vis-condition'] = JSON.stringify(visibilityDataObj);
            selectedComponent.addAttributes(selectedComponentAttrs);
          } else {
            delete selectedComponentAttrs['data-vis-condition'];
            selectedComponent.setAttributes(selectedComponentAttrs);
          }
        });
      });
  }

  return selectedComponentAttrs;
}

function loadVisibilityPanelContent(
  visibilityContent,
  hasPageCollection,
  hasParentCMS,
  environments,
  enableMultiTenant,
  multiTenantCollection,
  userSettingsCollection,
  subTenantCollection,
  snippetCollectionName,
  snippetType,
) {
  console.log('🚀 ~ file: configureEditorCommands.js:1140 ~ enableMultiTenant:', enableMultiTenant);
  console.log(
    '🚀 ~ file: configureEditorCommands.js:1140 ~ multiTenantCollection:',
    multiTenantCollection,
  );
  console.log(
    '🚀 ~ file: configureEditorCommands.js:1408 ~ userSettingsCollection:',
    userSettingsCollection,
  );

  let environmentHtml = '';

  environments &&
    environments.map((environment) => {
      environmentHtml += `
      
      <div class="gjs-trt-trait__wrp">
          <div class="gjs-trt-trait gjs-trt-trait--checkbox">
              <div class="gjs-label-wrp gjs-label-flex-g" data-label="">
                  <div class="gjs-label" title="${environment.name}">Hide on ${environment.name} (${environment.envType})</div>
              </div>
              <div class="gjs-field-wrp gjs-field-wrp--checkbox" data-input="">
                  <label class="gjs-field gjs-field-checkbox" data-input="">
                      <input id="${environment.envType}" name="${environment.envType}" type="checkbox" placeholder="" value="${environment.envType}">
                      <i class="gjs-chk-icon"></i>
                  </label>
              </div>
          </div>
      </div>

      `;
    });

  visibilityContent.innerHTML = `
      
<div id="gjs-sm-when-user" class="gjs-sm-sector gjs-sm-sector__when-user" style="display: block;">
  <div class="gjs-sm-title gjs-visibility-condition" data-sector-title="">
      User Status <i class="gjs-visibility__info-fa fa fa-info-circle" style="margin-left: 5px" title="Define a condition based on whether the\nUser is LoggedIn or Not LoggedIn."></i>
  </div>
  <div class="gjs-sm-properties">
      <div id="gjs-sm-when-current-user" class="gjs-sm-property gjs-sm-select gjs-sm-property__when-current-user" style="display: block;">
          <div class="gjs-sm-label" data-sm-label="">
              <span class="gjs-sm-icon " title="">
                  User Login Status
              </span>
              <b class="gjs-sm-clear" data-clear-style="" style="display: none;">⨯</b>
          </div>
          <div class="gjs-fields" data-sm-fields="">
              <div class="gjs-field gjs-select">
                  <span id="gjs-sm-input-holder">
                      <select id="gjs-sm-property-select__when-current-user">
                          <option value="">- Doesn't Matter -</option>
                          <option value="LOGGED_IN">User is Logged In</option>
                          <option value="NOT_LOGGED_IN">User is Not Logged In</option>
                      </select>
                  </span>
                  <div class="gjs-sel-arrow">
                      <div class="gjs-d-s-arrow"></div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
<div id="gjs-sm-when-condition" class="gjs-sm-sector gjs-sm-sector__when-condition" style="display: block;">
  <div class="gjs-sm-title gjs-visibility-condition" data-sector-title="">
      (AND) Compare With Field Value <i class="gjs-visibility__info-fa fa fa-info-circle" style="margin-left: 5px" title="Define the When condition based on the field value."></i>
  </div>
  <div class="gjs-sm-properties">
      <div id="gjs-sm-when-collection-from" class="gjs-sm-property gjs-sm-select gjs-sm-property__when-collection-from" style="display: block;">
          <div class="gjs-sm-label" data-sm-label="">
              <span class="gjs-sm-icon " title="">
                  From (Source)
              </span>
              <b class="gjs-sm-clear" data-clear-style="" style="display: none;">⨯</b>
          </div>
          <div class="gjs-fields" data-sm-fields="">
              <div class="gjs-field gjs-select">
                  <span id="gjs-sm-input-holder">
                      <select id="gjs-sm-property-select__when-collection-from">
                          <option value="">- Select One -</option>
                          <option value="CURRENT_LOGGEDIN_USER">Current LoggedIn User</option>
                          ${
                            enableMultiTenant &&
                            multiTenantCollection &&
                            `<option value="CURRENT_LOGGEDIN_TENANT">Current LoggedIn ${multiTenantCollection.collectionTitle}</option>`
                          }
                          ${
                            enableMultiTenant &&
                            userSettingsCollection &&
                            `<option value="CURRENT_LOGGEDIN_USER_SETTINGS">Current LoggedIn ${userSettingsCollection.collectionTitle}</option>`
                          }
                          ${
                            enableMultiTenant &&
                            subTenantCollection &&
                            `<option value="CURRENT_LOGGEDIN_SUB_TENANT">Current LoggedIn ${subTenantCollection.collectionTitle}</option>`
                          }
                          ${
                            hasPageCollection &&
                            `<option value="PAGE_COLLECTION">Page Collection</option>`
                          }
                          ${
                            snippetCollectionName &&
                            `<option value="SNIPPET_COLLECTION">${snakeCaseToTitleCase(
                              snippetType,
                            )} Collection</option>`
                          }
                          ${
                            hasParentCMS &&
                            `<option value="PARENT_CMS_COMPONENT">Parent Data Group/Table</option>`
                          }
                          <option value="BROWSER_STORAGE">Browser Storage Location</option>
                      </select>
                  </span>
                  <div class="gjs-sel-arrow">
                      <div class="gjs-d-s-arrow"></div>
                  </div>
              </div>
          </div>
      </div>

      <div
        id="gjs-sm-when-bsl"
        class="gjs-sm-property gjs-sm-select gjs-sm-property__when-bsl d-none"
        style="display: block;"
      >
        <div class="gjs-sm-label" data-sm-label="">
          <span class="gjs-sm-icon " title="">
            Browser Storage Location
          </span>
          <b class="gjs-sm-clear" data-clear-style="" style="display: none;">
            ⨯
          </b>
        </div>
        <div class="gjs-fields" data-sm-fields="">
          <div class="gjs-field gjs-select">
            <span id="gjs-sm-input-holder">
              <select id="gjs-sm-property-select__when-bsl">
                <option value="">- Select One -</option>
                <option value="SESSION_STORAGE">Session Storage</option>
                <option value="LOCAL_STORAGE">Local Storage</option>
                <option value="COOKIES">Cookies</option>
              </select>
            </span>
            <div class="gjs-sel-arrow">
              <div class="gjs-d-s-arrow"></div>
            </div>
          </div>
        </div>
      </div>  

      <div id="gjs-sm-when-bsl-key" class="gjs-sm-property gjs-sm-select gjs-sm-property__when-bsl-key d-none" style="display: block;">
          <div class="gjs-sm-label" data-sm-label="">
              <span class="gjs-sm-icon" title="">
                  Browser Storage Key
              </span>
              <b class="gjs-sm-clear" data-clear-style="" style="display: none;">⨯</b>
          </div>
          <div class="gjs-fields" data-sm-fields="">
              <div class="gjs-field-wrp gjs-field-wrp--text" data-input="">
                  <div class="gjs-field gjs-field-text" data-input="">
                      <input id="gjs-sm-property-input__when-bsl-key" type="text" placeholder="eg. JSON key here">
                  </div>
              </div>
          </div>
      </div>

      <div id="gjs-sm-when-collection-field" class="gjs-sm-property gjs-sm-select gjs-sm-property__when-collection-field" style="display: block;">
          <div class="gjs-sm-label" data-sm-label="">
              <span class="gjs-sm-icon " title="">
                  Collection Field
              </span>
              <b class="gjs-sm-clear" data-clear-style="" style="display: none;">⨯</b>
          </div>
          <div class="gjs-fields" data-sm-fields="">
              <div class="gjs-field gjs-select">
                  <span id="gjs-sm-input-holder">
                      <select id="gjs-sm-property-select__when-collection-field">
                          <option value="">- Select One -</option>
                      </select>
                  </span>
                  <div class="gjs-sel-arrow">
                      <div class="gjs-d-s-arrow"></div>
                  </div>
              </div>
          </div>
      </div>
      <div id="gjs-sm-when-condition" class="gjs-sm-property gjs-sm-select gjs-sm-property__when-condition" style="display: block;">
          <div class="gjs-sm-label" data-sm-label="">
              <span class="gjs-sm-icon " title="">
                  Condition
              </span>
              <b class="gjs-sm-clear" data-clear-style="" style="display: none;">⨯</b>
          </div>
          <div class="gjs-fields" data-sm-fields="">
              <div class="gjs-field gjs-select">
                  <span id="gjs-sm-input-holder">
                      <select id="gjs-sm-property-select__when-condition">
                          <option value="">- Select One -</option>
                          <option value="EQUALS">Equals (=)</option>
                          <option value="NOT_EQUALS">Not Equals (!=)</option>
                          <option value="IS_NULL">Is Null / Doesn't Exist (Value doesn't exist)</option>
                          <option value="IS_NOT_NULL">Is Not Null / Is Exists (Value exists)</option>
                          <option value="IS_BOOLEAN_TRUE">Is True (Value is boolean true)</option>
                          <option value="IS_BOOLEAN_FALSE">Is False (Value is boolean false)</option>
                          <option value="IN_LIST">In List (Value exists in List)</option>
                          <option value="NOT_IN_LIST">Not In List (Value doesn't exist in List)</option>
                          <option value="LESS_THAN">Less Than (<)</option> <option value="GREATER_THAN">Greater Than (>)</option>
                          <option value="LESS_THAN_EQUALS_TO">Less Than Equals To (<=)</option> <option value="GREATER_THAN_EQUALS_TO">Greater Than Equals To (>=)</option>
                      </select>
                  </span>
                  <div class="gjs-sel-arrow">
                      <div class="gjs-d-s-arrow"></div>
                  </div>
              </div>
          </div>
      </div>
      <div id="gjs-sm-when-value" class="gjs-sm-property gjs-sm-select gjs-sm-property__when-value" style="display: block;">
          <div class="gjs-sm-label" data-sm-label="">
              <span class="gjs-sm-icon " title="">
                  Value
              </span>
              <b class="gjs-sm-clear" data-clear-style="" style="display: none;">⨯</b>
          </div>
          <div class="gjs-fields" data-sm-fields="">
              <div class="gjs-field gjs-select">
                  <span id="gjs-sm-input-holder">
                      <select id="gjs-sm-property-select__when-value">
                          <option value="">- Select One -</option>
                      </select>
                  </span>
                  <div class="gjs-sel-arrow">
                      <div class="gjs-d-s-arrow"></div>
                  </div>
              </div>
          </div>
      </div>
      <div id="gjs-sm-when-fixed-value" class="gjs-sm-property gjs-sm-select gjs-sm-property__when-fixed-value" style="display: block;">
          <div class="gjs-sm-label" data-sm-label="">
              <span class="gjs-sm-icon" title="">
                  Fixed Value
              </span>
              <b class="gjs-sm-clear" data-clear-style="" style="display: none;">⨯</b>
          </div>
          <div class="gjs-fields" data-sm-fields="">
              <div class="gjs-field-wrp gjs-field-wrp--text" data-input="">
                  <div class="gjs-field gjs-field-text" data-input="">
                      <input id="gjs-sm-property-input__when-fixed-value" type="text" placeholder="eg. Fixed Value here">
                  </div>
              </div>
          </div>
      </div>

      <div id="gjs-sm-when-bsl-fixed-value" class="gjs-sm-property gjs-sm-select gjs-sm-property__when-bsl-fixed-value d-none" style="display: block;">
        <div class="gjs-sm-label" data-sm-label="">
            <span class="gjs-sm-icon" title="">
                Browser Storage Value
            </span>
            <b class="gjs-sm-clear" data-clear-style="" style="display: none;">⨯</b>
        </div>
        <div class="gjs-fields" data-sm-fields="">
            <div class="gjs-field-wrp gjs-field-wrp--text" data-input="">
                <div class="gjs-field gjs-field-text" data-input="">
                    <input id="gjs-sm-property-input__when-bsl-fixed-value" type="text" placeholder="eg. Session value here">
                </div>
            </div>
        </div>
      </div>

  </div>
</div>
<div id="gjs-sm-then-condition" class="gjs-sm-sector gjs-sm-sector__then-condition" style="display: block;">
  <div class="gjs-sm-title gjs-visibility-condition" data-sector-title="">
      Define Component Visibility <i class="gjs-visibility__info-fa fa fa-info-circle" style="margin-left: 5px" title="Select the visibility of a component."></i>
  </div>
  <div class="gjs-sm-properties">
      <div id="gjs-sm-then-comp-visibility" class="gjs-sm-property gjs-sm-select gjs-sm-property__then-comp-visibility" style="display: block;">
          <div class="gjs-sm-label" data-sm-label="">
              <span class="gjs-sm-icon " title="">
                  Component's Visibility <i class="gjs-visibility__info-fa fa fa-info-circle" title="Select one of the option to adjust the visbility & interactivity of the component."></i>
              </span>
              <b class="gjs-sm-clear" data-clear-style="" style="display: none;">⨯</b>
          </div>
          <div class="gjs-fields" data-sm-fields="">
              <div class="gjs-field gjs-select">
                  <span id="gjs-sm-input-holder">
                      <select id="gjs-sm-property-select__then-comp-visibility">
                          <option value="">- Select One -</option>
                          <option value="SHOW">Show</option>
                          <option value="HIDE">Hide</option>
                          <option value="DISABLED">Disabled</option>
                          <option value="READ_ONLY">Read Only</option>
                      </select>
                  </span>
                  <div class="gjs-sel-arrow">
                      <div class="gjs-d-s-arrow"></div>
                  </div>
              </div>
          </div>
      </div>
      <div id="gjs-sm-then-comp-add-class-visibility" class="gjs-sm-property gjs-sm-select gjs-sm-property__then-add-class-comp-visibility" style="display: block;">
        <div class="gjs-sm-label" data-sm-label="">
            <span class="gjs-sm-icon " title="">
                Add CSS Class (Optional) <i class="gjs-visibility__info-fa fa fa-info-circle" title="Enter CSS class(es) separated by (,) comma to add to the component."></i>
            </span>
            <b class="gjs-sm-clear" data-clear-style="" style="display: none;">⨯</b>
        </div>
        <div class="gjs-fields" data-sm-fields="">
          <div class="gjs-field-wrp gjs-field-wrp--text" data-input="">
              <div class="gjs-field gjs-field-text" data-input="">
                  <input id="gjs-sm-property-input__then-add-class-value" type="text" placeholder="eg. CSS Class here">
              </div>
          </div>
        </div>
      </div>
      <div id="gjs-sm-then-comp-remove-class-visibility" class="gjs-sm-property gjs-sm-select gjs-sm-property__then-remove-class-comp-visibility" style="display: block;">
        <div class="gjs-sm-label" data-sm-label="">
            <span class="gjs-sm-icon " title="">
                Remove CSS Class (Optional) <i class="gjs-visibility__info-fa fa fa-info-circle" title="Enter CSS class(es) separated by (,) comma to remove from the component."></i>
            </span>
            <b class="gjs-sm-clear" data-clear-style="" style="display: none;">⨯</b>
        </div>
        <div class="gjs-fields" data-sm-fields="">
          <div class="gjs-field-wrp gjs-field-wrp--text" data-input="">
              <div class="gjs-field gjs-field-text" data-input="">
                  <input id="gjs-sm-property-input__then-remove-class-value" type="text" placeholder="eg. CSS Class here">
              </div>
          </div>
        </div>
      </div>
  </div>
</div>
<div id="gjs-sm-env-bypass" class="gjs-sm-sector gjs-sm-sector__env-bypass" style="display: block;">
  <div class="gjs-sm-title gjs-visibility-condition" data-sector-title="">
      Environment Based Visibility <i class="gjs-visibility__info-fa fa fa-info-circle" style="margin-left: 5px" title="Visibility based on selected Environments.\nIt'll supersede the defined When Conditions."></i>
  </div>
  <div class="gjs-sm-properties">
      <div id="gjs-sm-env-bypass-comp-visibility" class="gjs-sm-property gjs-sm-select gjs-sm-property__env-bypass-comp-visibility" style="display: block; width: 100%">
          <div class="gjs-trt-traits gjs-one-bg gjs-two-color">
              ${environmentHtml}
          </div>
      </div>
  </div>
</div>

      `;
}

function filterBlocksByCategory(allBlocks) {
  const filteredPreBuiltLayouts = [],
    filteredThemePages = [],
    filteredSections = [],
    filtered = [];
  allBlocks.forEach((block) => {
    let blockCategory = block.get('category');
    blockCategory = typeof blockCategory.id === 'undefined' ? blockCategory : blockCategory.id;
    if (blockCategory === 'Sections') {
      filteredSections.push(block);
    } else if (blockCategory.startsWith('<span style="display: none;">Pre-Built</span>')) {
      filteredPreBuiltLayouts.push(block);
    } else if (blockCategory.startsWith('Theme Page')) {
      filteredThemePages.push(block);
    } else {
      filtered.push(block);
    }
  });
  return { filteredPreBuiltLayouts, filteredThemePages, filteredSections, filtered };
}
